export const cloudinaryConfig = {
  cloudName: import.meta.env.VITE_CLOUDINARY_CLOUD_NAME || 'gawn39xg',
  uploadPreset: import.meta.env.VITE_CLOUDINARY_UPLOAD_PRESET || 'offerlifetime_preset',
  apiKey: import.meta.env.VITE_CLOUDINARY_API_KEY || '582374277516637',
  apiSecret: import.meta.env.VITE_CLOUDINARY_API_SECRET || 'u4QrSj5y5aUSnLxAY5JUdX5qmXc',
  folder: import.meta.env.VITE_CLOUDINARY_FOLDER || 'offerlifetime_folder',
};

export const uploadVideoToCloudinary = async (file, onProgress) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', cloudinaryConfig.uploadPreset);
  formData.append('folder', cloudinaryConfig.folder);
  
  // Determine resource type based on file type
  const resourceType = file.type.startsWith('image/') ? 'image' : 'video';
  formData.append('resource_type', resourceType);

  try {
    const response = await fetch(
      `https://api.cloudinary.com/v1_1/${cloudinaryConfig.cloudName}/${resourceType}/upload`,
      {
        method: 'POST',
        body: formData,
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error?.message || 'Upload failed');
    }

    const data = await response.json();
    return {
      url: data.secure_url,
      publicId: data.public_id,
      duration: data.duration,
      format: data.format,
    };
  } catch (error) {
    console.error('Error uploading to Cloudinary:', error);
    throw error;
  }
};

export const deleteVideoFromCloudinary = async (publicId) => {
  try {
    const timestamp = Math.round(new Date().getTime() / 1000);
    const signature = await generateSignature(publicId, timestamp);

    const formData = new FormData();
    formData.append('public_id', publicId);
    formData.append('signature', signature);
    formData.append('api_key', cloudinaryConfig.apiKey);
    formData.append('timestamp', timestamp);

    const response = await fetch(
      `https://api.cloudinary.com/v1_1/${cloudinaryConfig.cloudName}/video/destroy`,
      {
        method: 'POST',
        body: formData,
      }
    );

    return await response.json();
  } catch (error) {
    console.error('Error deleting from Cloudinary:', error);
    throw error;
  }
};

const generateSignature = (publicId, timestamp) => {
  const str = `public_id=${publicId}&timestamp=${timestamp}${cloudinaryConfig.apiSecret}`;
  return sha1(str);
};

const sha1 = async (str) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(str);
  const hashBuffer = await crypto.subtle.digest('SHA-1', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
};
